import { ReactNode } from "react";

interface CompoundProps {
	children: ReactNode;
}

function CustomerApplicationDetail(props: CompoundProps) {
	const { children } = props;

	return (
		<>{children}</>
	)
}

type CustomerApplicationDetailTitleProps = {
	title: string;
}
function Title(props: CustomerApplicationDetailTitleProps) {
	const { title } = props;
	return <h2>{title}</h2>
}

/**
 * Compound react component for the CustomerApplicationDetail page so that it is all consistent.
 */
CustomerApplicationDetail.Title = Title;


export default CustomerApplicationDetail;